import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';

import { AppState, Actions } from '../../../store/root-reducer';
import { Customer } from 'modules/shared/models/customer.models';

import { CustomerService } from 'modules/core/services/customer.service';

@Injectable()
export class ScreeningGuard implements CanActivate {

  constructor(private store: Store<AppState>,
              private customer: CustomerService) { }

  getCustomer(route: ActivatedRouteSnapshot): Observable<Customer> {
    const id: number = route.params['id'];
    this.store.dispatch(new Actions.customer.GetCustomer({
      customerId: id,
      quietUpdate: true
    }));

    return this.customer.getCustomer(id).pipe(
      take(1)
    );
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return of(true);
  }
}
